import React, { Component } from 'react';

import Swipe from 'react-easy-swipe';

import './step.scss';
import { StepAPI } from '@philips-emr/tws-components-api';
import { Expression, StepStage } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider, Oswald } from '@philips-emr/tws-core';
import { arrayOf, bool, element, eventListener, expression, number, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, getSlot, isEnumValid, isMobile, trigger } from '@philips-emr/tws-utils';

import { Link } from '..';

@AwesomeComponent({ type: ComponentType.FORM, api: StepAPI })
class Step extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
    collapsed: bool.notEnumerable(),
    displayIndex: number,
    done: bool.notEnumerable(),
    enabled: bool.notEnumerable(),
    identifier: string,
    index: number.notEnumerable(),
    last: bool.notEnumerable(),
    onEdit: eventListener,
    onPrevious: eventListener,
    onSubmit: eventListener,
    result: oneOfType([element, arrayOf(element)]).notEnumerable(),
    stage: oneOf(enumValues(StepStage)).notEnumerable(),
    title: expression,
    uuid: string,
  };

  static defaultProps = {
    collapsed: true,
    index: 0,
    enabled: false,
  };

  renderContainer(options) {
    const { slot, acceptedTypes } = options;
    const { children, uuid } = this.props;

    const content = getSlot(children, slot);
    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={acceptedTypes} slot={slot} uuid={uuid}>
        {content}
      </Container>
    );
  }

  getClassName() {
    const { className, collapsed, done, enabled, last, stage } = this.props;

    return classNames({
      'c-step': true,
      'is-collapsed': Oswald.isDesigning() ? false : collapsed,
      'is-done': done,
      'is-last': last,
      'is-disabled': !enabled,
      [`is-${stage}`]: stage && isEnumValid(StepStage, stage),
      [className]: Boolean(className),
    });
  }

  renderHeader() {
    const { displayIndex, identifier, index, onEdit, onPrevious, stage, title } = this.props;

    const idx = displayIndex ? displayIndex : index + 1;
    const formattedIndex = `0${idx}`.slice(-2) + '.';

    const onClick = () => {
      if (!isMobile() || stage !== StepStage.PREV) {
        return;
      }

      onEdit(identifier);
    };

    return (
      <Swipe
        className="c-step__header"
        onClick={onClick}
        onSwipeRight={isMobile() ? trigger(onPrevious, identifier) : undefined}
        tolerance={100}
      >
        <div className="c-step__index">{formattedIndex}</div>
        <div className="c-step__title">{msg(title)}</div>

        <div className="c-step__actions u-hide@xsm">
          <Link onClick={trigger(onEdit, identifier)} value={Expression.EDIT} />
        </div>
      </Swipe>
    );
  }

  renderResult() {
    const { collapsed, done, result } = this.props;

    if (!collapsed && !done) {
      return null;
    }

    return (
      <div className="c-step__result u-hide@xsm">
        <div className="c-step__result-row">
          {result}
        </div>
      </div>
    );
  }

  renderContent() {
    const options = {
      acceptedTypes: [],
      slot: 'step-content',
    };

    return (
      <div className="c-step__content">
        <div className="c-step__container">
          {this.renderContainer(options)}
        </div>

        <a className="c-link c-step__next u-hide@xsm" onClick={trigger(this.props.onSubmit, this.props.identifier)}>
          {msg(Expression.GO_TO_NEXT_STEP)}
          <span className="c-step__desc">
            &nbsp; ({msg(Expression.OR_PRESS_ENTER)})
          </span>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderHeader()}
        {this.renderResult()}
        {this.renderContent()}
      </div>
    );
  }
}

export default Step;
